(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luca-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luca-story-reveal')) {
    class LucaStoryReveal extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('is-visible');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries[0]?.isIntersecting) {
              this.classList.add('is-visible');
              this.observer.disconnect();
            }
          },
          {
            threshold: 0.16,
            rootMargin: '0px 0px -8% 0px'
          }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    customElements.define('luca-story-reveal', LucaStoryReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Move the existing sorting control, preserving its form and event handlers.
  if (!window.garzaCollectionSortInstalled) {
    window.garzaCollectionSortInstalled = true;
    const mobileSortQuery = window.matchMedia('(max-width: 749px)');
    const originalPositions = new WeakMap();
    const observedLists = new WeakSet();
    function arrangeSort(list) {
      const controls = list.querySelectorAll('#filters-drawer .facets-drawer__filters > sorting-filter-component');
      controls.forEach(control => {
        const parent = control.parentElement;
        if (mobileSortQuery.matches) {
          if (!originalPositions.has(control)) {
            const marker = document.createComment('Original sorting position');
            parent.insertBefore(marker, control);
            originalPositions.set(control, marker);
          }
          if (parent.firstElementChild !== control) parent.insertBefore(control, parent.firstChild);
        } else {
          const marker = originalPositions.get(control);
          if (marker?.parentNode === parent) {
            parent.insertBefore(control, marker.nextSibling);
            marker.remove();
          } else if (marker && parent.lastElementChild !== control) {
            parent.append(control);
          }
          originalPositions.delete(control);
        }
      });
    }
    function installCollectionSort() {
      document.querySelectorAll('results-list[data-garza-collection-layout]').forEach(list => {
        if (!observedLists.has(list)) {
          observedLists.add(list);
          new MutationObserver(() => { if (list.isConnected) arrangeSort(list); })
            .observe(list, { childList: true, subtree: true });
        }
        arrangeSort(list);
      });
    }
    mobileSortQuery.addEventListener('change', installCollectionSort);
    document.addEventListener('shopify:section:load', installCollectionSort);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installCollectionSort, { once: true });
    else installCollectionSort();
  }


  } catch(e) { console.error(e); }
})();
})();
